import { useRouter } from 'next/router';

import Link from 'next/link';
import styled from 'styled-components';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { IconArrow } from '@fabric-app/icons/svg';

const StyledHeader = styled.header`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-bottom: auto;
  position: relative;
  width: 100%;
  padding: 0 2.5rem;
  padding-top: 3rem;

  ${mediaMobile} {
    padding: 0 1.25rem;
    padding-top: 2.5rem;
  }
`;

const BackButton = styled.button`
  align-items: center;
  padding: 0.625rem;
  color: var(${cssVar['color-text-primary']});
  display: flex;
  font-size: 15px;
  font-weight: 500;
  line-height: 17px;
  gap: 6px;

  svg {
    height: 14px;
    width: auto;
  }
`;

const Header = () => {
  const router = useRouter();

  return (
    <StyledHeader>
      {router.pathname !== '/signin' && (
        <BackButton as={Link} href={'/signin'}>
          <IconArrow /> back
        </BackButton>
      )}
    </StyledHeader>
  );
};

export default Header;
